export const RU_LANGUAGE = 'ru';
export const EN_LANGUAGE = 'en';
export const PL_LANGUAGE = 'pl';
export const UA_LANGUAGE = 'uk';
export const DEFAULT_LANGUAGE = RU_LANGUAGE;
export const AVAILABLE_LANGUAGES = [
  RU_LANGUAGE,
  EN_LANGUAGE,
  UA_LANGUAGE,
  PL_LANGUAGE
];


// WEBPACK FOOTER //
// ./src/lang/constants.js